import React, { useRef, useState } from "react";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import cssClasses from "./UpdatePassword.module.css";
import Close from "../../Components/Icons/Close";
import Button from "../../Subcomponents/Button";
import TextField from "@mui/material/TextField";
import SearchIcon from "../../Assets/Images/SearchIcon.svg";

import { updateStatus, insertFoSLogs } from "../../Services/FOSList";
import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import {
  getCpBillingName,
  getSalesPerson,
  handleErrors,
  updatePassword,
  updatePasswordFlag,
  updateRecommentdationToFoSTable,
} from "../../Services/LoginService";
import { Network } from "@capacitor/network";
import CustomInput from "../../Subcomponents/CustomInput";
import { useEffect } from "react";
import { Paper } from "@material-ui/core";
import { Autocomplete, createTheme, ThemeProvider } from "@mui/material";
import { debounce } from "lodash";
import { supabase } from "../../supabaseClient";

const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "0rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "3rem",
    lineHeight: "3.8rem",
    color: "#101828",
    marginBottom: "1.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
    marginTop:'1rem'
  },
}));
const AutoCompleTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: "1.6rem !important",
          fontFamily: "Inter-Medium !important",
          lineHeight: "2.4rem !important",
          borderRadius: 20,
          borderColor: "#84CAFF !important",
          paddingRight: "3rem !important",
          padding: "0.5rem 1.4rem !important",
          "& input[text]": {
            color: "#101828 !important",
          },
          "& input[input:-internal-autofill-selected]": {
            background: "#F2F4F7 !important",
            borderBottom: "1px solid #878383 !important",
          },
          "& input[value]": {
            background: "#FFFFF !important",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none !important",
          },
          "&.Mui-focused": {
            background: "#FFFFFF !important",
            border: "1px solid #84CAFF !important",

            boxShadow:
              "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF !important",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& label": {
            fontSize: "1.6rem !important",
          },
        },
      },
    },
  },
});
const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: "1.6rem !important",
          fontFamily: "Inter-Medium !important",
          lineHeight: "2.4rem !important",
          borderRadius: 20,
          borderColor: "#84CAFF !important",
          paddingRight: "3rem !important",
          "& input[text]": {
            color: "#101828 !important",
          },
          "& input[input:-internal-autofill-selected]": {
            background: "#F2F4F7 !important",
          },
          "& input[value]": {
            background: "#FFFFF !important",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&.Mui-focused": {
            background: "#FFFFFF",
            border: "1px solid #84CAFF !important",
            boxShadow:
              "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& label": {
            fontSize: "1.6rem !important",
          },
        },
      },
    },
  },
});
export default function UpdatePassword({ open, handleClose, saveResp, data }) {
  const classes = useStyles();
  const [helperText, setHelperText] = useState({
    isPasswordValid: "",
    recommedation:"",
    CPEName:""
  });
  const [newPassword, setNewPassword] = useState("");
  const [salesPersonArray, setSalesPersonArray] = useState([]);
  const [cpDispalyId, setCpDisplayId] = useState("");
  const [recommedation, setRecommendation] = useState("");
  const [CPEDetails, setCPEDetails] = useState("");
  const [getCPENAME, setGetCPEName] = useState([]);
  useEffect(() => {
    console.log({ data });
  }, []);

  function validatePasswordAndSalesId(){
    var form = true;
    if (newPassword === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isPasswordValid = "Please Enter new Password";
        return { ...preValue };
      });
    }
    // if (recommedation === ""||recommedation===undefined) {
    //   form = false;
    //   setHelperText((preValue) => {
    //     preValue.recommedation = "Please Select Sales Person";
    //     return { ...preValue };
    //   });
    // }
    if(data.user_metadata.type==='FOS'&&data.cpId===null){

      if(CPEDetails===''){
        form = false;
          setHelperText((preValue) => {
            preValue.CPEName = "Please Select CPE";
            return { ...preValue };
          });
      }
    }
    return {
      flag: form,
    };
  }
  function submit() {
    //Api Call
    if(data.user_metadata.type==='CP'){
        if(helperText.isPasswordValid===''&&newPassword!==''){
            updatePasswordFun();
        }else{
            setHelperText((pre)=>{
                pre.isPasswordValid="Please enter new password";
                return {...pre}
            })
        }
    }
    if(data.user_metadata.type==='FOS'){
    let flag=  validatePasswordAndSalesId();
    if(flag.flag){
      console.log(newPassword,CPEDetails)
          updatePasswordFun();
          if(data.user_metadata.type==='FOS'&&data.cpId===null){
            updateCPE();
          }
        }
   
        
    }
  }
  function updatePasswordFun() {
    supabase.auth.api.updateUser(JSON.parse(localStorage.getItem('supabase.auth.token')).currentSession.access_token, { password: newPassword }).then((resp) => {
      console.log(resp);
      updatePasswordFlag(true,data.user_metadata.type,data.user_metadata.type==='CP'?data?.cpId:data.id).then((flagUpdated)=>{

      }).catch((err)=>{
        console.log(err);
      })
      successTost('Password Updated Successfully');
      saveResp(true);
         handleClose();
    }).catch((err) => {
      console.log(err);
      errorTost(err.message);
    })
    
  }
  function updateCPE(){
    updateRecommentdationToFoSTable(CPEDetails.value,data.id).then((resp)=>{
        console.log(resp);
        
    }).catch((err)=>{
      console.log(err);
    })
  }
  function close() {
    handleClose();
  }
  const getSalesPersonDetails = useRef(
    debounce((e) => {
      console.log(e);
      if (e !== "") {
        getSalesPerson(e)
          .then((resp) => {
            console.log(resp);
            if (resp.length !== 0) {
              setSalesPersonArray(resp);

              setHelperText((pre) => {
                pre.salesPersonName = "";
                return { ...pre };
              });
            } else {
              helperText.salesPersonName = "";
              setSalesPersonArray([]);
              setRecommendation("");
              setHelperText((pre) => {
                pre.salesPersonName = "";
                return { ...pre };
              });
            }
          })
          .catch((err) => {
            errorTost(err.message);
            setSalesPersonArray([]);
            setRecommendation("");
          });
      } else {
        setSalesPersonArray([]);
        setRecommendation("");
      }
    }, 800)
  ).current;
  const getCPEDetails = useRef(
    debounce((e) => {
      console.log(e);
      if (e !== "") {
        Network.getStatus().then((resp) => {
          if (resp.connected) {
            getCpBillingName(e)
              .then((data) => {
                console.log(data);
                if (data.length !== 0) {
                  setGetCPEName(data);
                } else {
                  setCPEDetails(null);
                  setGetCPEName([]);
                }
              })
              .catch((err) => {
                handleErrors(err, "getCpBillingName");
              });
          } else {
            offlineToast();
          }
        });
      } else {
        setCPEDetails(null);
        setGetCPEName([]);
      }
    }, 800)
  ).current;
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
      button
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={classes.wrapperIcons}>
          {/* {icon} */}

          {/* <span className={classes.closeIcon} onClick={handleClose}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span> */}
          <div className={cssClasses.wrapperHeader}>Update Password</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          <div style={{ textAlign: "left" }}>
            <CustomInput
              value={newPassword}
              label={"Password"}
              mandatory={true}
              handleChange={(value) => {
                let errors = helperText;
                if (!value.trim()) {
                  errors.isPasswordValid = "Please Enter Password";
                } else if (value.search(/[A-Z]/) < 0) {
                  errors.isPasswordValid =
                    "Password should contain atleast 1 Uppercase.";
                }
                //  else if (value.search(/[a-z]/) < 0) {
                //   errors.isPasswordValid =
                //     "Password should contain atleast 1 LowerCase.";
                // }
                else if (value.search(/[0-9]/) < 0) {
                  errors.isPasswordValid =
                    "Password should contain atleast 1 number.";
                } else if (value.length < 6) {
                  errors.isPasswordValid =
                    "Password should contain atleast 6 Characters.";
                } else {
                  errors.isPasswordValid = "";
                }
                setHelperText(errors);
                setNewPassword(value);
              }}
              placeholder="Enter your password"
              inputType="password"
              helperText={helperText.isPasswordValid}
              onKeyPress={(event) => {
                console.log(event);
              }}
            />
          </div>
          {data.user_metadata.type==='FOS'&&data.cpId===null&&(
          // <div style={{ position: "relative" }}>
          //   <div className={cssClasses.blockLabel}>
          //     Recommended by Sales person
          //     <span style={{ color: "red" }}> *</span>
          //   </div>
          //   <ThemeProvider theme={AutoCompleTheme}>
          //     <Autocomplete
          //       id="free-solo-2-demo"
          //       sx={{
          //         fontSize: "1.6rem !important",
          //         fontFamily: "Inter-Medium !important",
          //         lineHeight: "2.4rem !important",
          //         // borderColor: "none !important",

          //         ".MuiOutlinedInput-root": {
          //           background: "#F2F4F7",

          //           borderRadius: "8px",
          //           "&.Mui-focused": {
          //             background: "#FFFFFF",
          //             border: "1px solid #84CAFF !important",
          //             boxShadow:
          //               "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF;",
          //           },
          //         },
          //         "& .MuiSvgIcon-root ": {
          //           display: "none !important",
          //         },
          //       }}
          //       value={recommedation}
          //       classes={{
          //         option: classes.textStyle,
          //       }}
          //       options={salesPersonArray.map((option) => {
          //         return { label: option.name, value: option.userId };
          //       })}
          //       PaperComponent={({ children }) => (
          //         <Paper
          //           style={{
          //             fontFamily: "Inter-Medium",
          //             fontSize: "1.6rem",
          //           }}
          //         >
          //           {children}
          //         </Paper>
          //       )}
          //       onChange={(event, newValue) => {
          //         console.log(newValue);
          //         setRecommendation(newValue);
          //       }}
          //       onInputChange={(event, newInputValue) => {
          //         // getCPEDetails(newInputValue);
          //         getSalesPersonDetails(newInputValue);
          //       }}
          //       renderInput={(params) => (
          //         <TextField
          //           classes={{ root: classes.customTextField }}
          //           sx={{
          //             fontSize: "1.6rem !important",
          //             fontFamily: "Inter-Medium !important",
          //             lineHeight: "2.4rem !important",
          //             textTransform: "capitalize",
          //             " .MuiFormHelperText-root ": {
          //               fontSize: "1.4rem !important",
          //               fontFamily: "Inter-Medium",
          //               lineHeight: "2rem",
          //               marginLeft: "0rem !important",
          //             },
          //           }}
          //           placeholder="Search Sales Person Name *"
          //           {...params}
          //           InputProps={{
          //             ...params.InputProps,
          //             type: "search",
          //             style: { fontSize: "1.6rem" },
          //           }}
          //           onChange={(e, v) => {
          //             // getCPEDetails(e.target.value);
          //             getSalesPersonDetails(e.target.value);
          //             setHelperText((pre)=>{
          //               pre.recommedation='';
          //               return {...pre}
          //             })
          //           }}
          //           helperText={helperText.recommedation}
          //           error={helperText.recommedation}
          //         />
          //       )}
          //     />
          //   </ThemeProvider>
          // </div>
          <div className={cssClasses.wrapperGeneralDetails}>
          <div className={cssClasses.detailText}>Select CPE </div>
          <div style={{ position: "relative" }}>
            <ThemeProvider theme={theme}>
              <Autocomplete
                id="free-solo-2-demo"
                sx={{
                  fontSize: "1.6rem !important",
                  fontFamily: "Inter-Medium !important",
                  lineHeight: "2.4rem !important",
                  borderColor: "none !important",
                  ".MuiOutlinedInput-root": {
                    background: "#F2F4F7",
                    borderRadius: "8px",
                    "&.Mui-focused": {
                      background: "#FFFFFF",
                      border: "1px solid #84CAFF !important",
                      boxShadow:
                        "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF;",
                    },
                    // "& .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline ":
                    //   {
                    //     borderColor: "white !important",
                    //   },
                  },
                  "& .MuiSvgIcon-root ": {
                    display: "none !important",
                  },
                }}
                value={CPEDetails}
                classes={{
                  option: classes.textStyle,
                }}
                options={getCPENAME.map((option) => {
                  return { label: option.billingName, value: option.cpId };
                })}
                PaperComponent={({ children }) => (
                  <Paper
                    style={{ fontFamily: "Inter-Medium", fontSize: "1.6rem" }}
                  >
                    {children}
                  </Paper>
                )}
                onChange={(event, newValue) => {
                  console.log(newValue);
                  setCPEDetails(newValue);
                  setHelperText((preValue) => {
                    preValue.CPEName = "";
                    return { ...preValue };
                  });
                }}
                //  inputValue={CPDetails}
                onInputChange={(event, newInputValue) => {
                  // setCPDetails(null);
                  console.log(newInputValue);
                  getCPEDetails(newInputValue);
                  setHelperText((preValue) => {
                    preValue.CPEName = "";
                    return { ...preValue };
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    classes={{ root: classes.customTextField }}
                    sx={{
                      fontSize: "1.6rem !important",
                      fontFamily: "Inter-Medium !important",
                      lineHeight: "2.4rem !important",
                      " .MuiFormHelperText-root ": {
                        fontSize: "1.4rem !important",
                        fontFamily: "Inter-Medium",
                        lineHeight: "2rem",
                        marginLeft: "0rem !important",
                      },
                    }}
                    placeholder="Search CPE Name *"
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: { fontSize: "3rem" },
                    }}
                    onChange={(e, v) => {
                      getCPEDetails(e.target.value);
                    }}
                    helperText={helperText.CPEName}
                    error={helperText.CPEName !== ""}
                  />
                )}
              />
            </ThemeProvider>
            {CPEDetails === null && (
              <div
                style={{
                  width: "2rem",
                  position: "absolute",
                  top: "2rem",
                  right: "1rem",
                }}
              >
                <img src={SearchIcon} alt={"SearchIcon"} />
              </div>
            )}
          </div>
        
        </div>
          )}
        </div>
        <div className={classes.wrapperButtons}>
          {/* <Button
            style={{
              color: "#344054",
              backgroundColor: "#ffffff",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
            }}
            btnName={"Cancel"}
            clicked={handleClose}
          /> */}

          <Button
            style={{
              color: "#ffffff",
              backgroundColor: "#1570EF",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
            }}
            btnName={"Submit"}
            clicked={submit}
            // disable={disableSubmitButton}
          />
        </div>
      </Box>
    </Modal>
  );
}
